import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Badge, Modal } from 'react-bootstrap';
import MessageForm from './MessageForm';
import { deleteMessagePolicy } from '../../actions/message-policy';
import { DataTable, Icon } from '../widgets';

const MessageAlertRow = ({ data, index, farmId, crewList, implementOperatorOptions, truckOperatorOptions, userList, incidentTypes }) => {
    if (!data) return <></>;

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);
    const [showDeleteModal, setDeleteModal] = useState(false);

    const handleDeleteConfim = () => {
        const params = {
            farm_uuid: farmId,
            policy_id: data.policy_id
        };

        dispatch(deleteMessagePolicy(params));
    };

    const selectedConfigs = data.hasOwnProperty('policy_config') && data.policy_config.length > 0 ? data.policy_config.filter(e => e.enabled) : [];

    // const getDelayTime = item => {
    //     const { configuration = null } = item;

    //     if (!configuration) return ''
    //     else if (configuration.hasOwnProperty('sms')) {
    //         const delayTime = configuration.sms.delay_duration;

    //         return `${delayTime} min`
    //     }
    // }

    return (
        <>
            <DataTable.Row                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        >
                <DataTable.Cell>{index + 1}</DataTable.Cell>
                <DataTable.Cell width={'200px'}>{data.entity_name}</DataTable.Cell>
                <DataTable.Cell width={'100px'}>{data.policy_type}</DataTable.Cell>

                <DataTable.Cell>
                    {data.phones.map((item, index) =>
                        <Badge
                            bg='light'
                            text='dark'
                            key={index}
                            className='mx-1 badge text-dark'
                            style={{ outline: 'solid 1px #878787' }}
                        >
                            {item ? item : <> - </>}
                        </Badge>
                    )}
                </DataTable.Cell>

                <DataTable.Cell>
                    <div style={{ textTransform: 'capitalize', display: 'flex', justifyItems: 'center', flexWrap: 'wrap' }}>
                        {selectedConfigs && selectedConfigs.length > 0 ?
                            selectedConfigs.map((item, index) =>
                                <Badge
                                    key={index}
                                    className='mx-1 border shadow-sm px-2'
                                    variant={data.policy_config[item] === 0 ? 'danger' : 'success'}
                                >
                                    <span>
                                        {item.incident_type_name}
                                    </span>

                                    {/* <span className='mx-1' style={{ color: 'black' }}> - </span>

                                    <span style={{ alignItems: 'center', textTransform: 'lowercase', color: '#2f2f2f' }} className='mx-1'>
                                        <i className="fa fa-clock-o" aria-hidden="true" style={{ fontSize: '12px' }} />
                                        <> {getDelayTime(item)} </>
                                    </span> */}
                                </Badge>
                            )
                            :
                            <div className='text-danger'>N/A</div>}
                    </div>
                </DataTable.Cell>

                <DataTable.Cell style={{ width: '64px' }} className='center'>
                    <Icon
                        className='fa fa-pencil mx-1 cursor-pointer'
                        title='Edit'
                        onClick={() => setShow(!show)}
                    />
                    <Icon
                        className='fa fa-trash mx-1 cursor-pointer'
                        title='Delete'
                        onClick={() => setDeleteModal(true)}
                    />
                </DataTable.Cell>
            </DataTable.Row>

            <Modal
                show={show}
                backdrop='static'
                className='equipment-modal-form'>
                <MessageForm
                    values={data}
                    onHide={(e) => setShow(e)}
                    crewList={crewList}
                    userList={userList}
                    incidentTypes={incidentTypes}
                    truckOperatorOptions={truckOperatorOptions}
                    implementOperatorOptions={implementOperatorOptions}
                />
            </Modal>

            <Modal.Confirm
                isOpen={showDeleteModal}
                onConfirm={handleDeleteConfim}
                iconClassName='fa fa-trash'
                body={`Do you really want to delete ${data.entity_name} SMS configuration?`}
                onHide={() => setDeleteModal(false)}
            />
        </>
    );
};

export default MessageAlertRow;